import Link from 'gatsby-link';
import React, { PureComponent } from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { Grid, zIndexes } from 'style';
import { MethodsService } from 'utils';

class GoBack extends PureComponent {
    constructor(props) {
        super(props);

    }

    render() {
        const text = this.props.text || 'Explore our work';
        const link = this.props.link || '/work';
        const fixed = this.props.fixed != null ? this.props.fixed : true;

        return (
            <GoBackBarWrapper id="GoBack" backgroundColor={this.props.backgroundColor} color={this.props.color} fixed={fixed}>
                <Grid.Row>
                    <Link to={link} css={goback_css}>
                        {text} {'>>'}
                    </Link>
                </Grid.Row>
            </GoBackBarWrapper>
        );
    }
}
const GoBackHeight = '6.5vw';
const GoBackHeightPortrait = '9.5vh';

const GoBackBarWrapper = styled.div`
    /* width: 100%; */
    height: ${GoBackHeightPortrait};
    @media (orientation: landscape){
      height: ${GoBackHeight};
    }
    position: relative;
    z-index: ${zIndexes.zGoBack};
    /* top: 0; */
    color: ${props => props.color || '#000'};

    & > div {
        /* width: 100%; */
        height: 100%;
        position: ${props => props.fixed == true ? 'absolute' : 'relative'};
        /* bottom: 0; */
        clip: rect(0, auto, auto, 0);
        background-color: ${props => props.backgroundColor || '#fff'};

        & > a {
            transform: perspective(0);
            position: ${props => props.fixed == true ? 'fixed' : 'relative'};
            top: 0;
        }
    }
`;
const goback_css = css`
    text-decoration: none;
    line-height: ${GoBackHeightPortrait};
    @media (orientation: landscape){
      line-height: ${GoBackHeight};
    }
    display: block;
    text-align: center;
    width: 100%;
`;

export default GoBack;
